import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import { LazyLoadMedia } from 'src/ui/common/organisms/lazy-load-media';
import styled from 'styled-components';
import { Button } from '../button';

export const StyledContainer = styled.div<{ isLanding?: boolean }>`
    position: relative;
    min-width: 172px;
    border-radius: 12px;
    cursor: pointer;
    overflow: hidden;

    ${media.sm`
        max-width: ${(isLanding: any) => (isLanding ? '474px' : '400px')};
    `};
`;

export const StyledLazyLoadImage = styled(LazyLoadMedia)`
    background: ${({ theme }) => theme.colors.grey900};
    overflow: hidden;
    border-radius: 12px;

    & img {
        transition: transform 0.2s ease-in 0s;
    }

    &:hover img {
        transform: scale(1.1, 1.1);
    }
`;

export const StyledInfo = styled(FlexBox)`
    padding: 12px 0;
`;

export const StyledButtonsWrapper = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
`;

export const StyledClaimButton = styled(Button)`
    margin-right: 2px;
`;

export const StyledSvgButton = styled(Button)``;

export const StyledArtType = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 1;
    background: ${({ theme }) => theme.colors.grey900};
    padding: 6px 10px 5px 8px;
    border-radius: 50px;

    :before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 7.5px;
        background-color: ${({ theme }) => theme.colors.white};
    }
`;

export const StyledArtTypeTitle = styled(Typography)`
    color: ${({ theme }) => theme.colors.white};
    font-size: 12px;
`;